import { Resource } from "i18next";
import t from "../../locales/nl.json";

export default t as Resource;
